import { ServiceExecutionSequenceModel } from 'app/app-model/diagnostic-service/service-execution-sequence.model';

export class SessionsModel {
  name: string;
  setSequence: ServiceExecutionSequenceModel;
  availableSecurityAccessModes: string[] = [];
}
